import React, { useEffect, useRef } from "react";
import { Animated, View, StyleSheet } from "react-native";
import config from "../config/config";

function Loader({ visible = false }) {
    if (!visible) return null;

    const popValue1 = useRef(new Animated.Value(0)).current;
    const popValue2 = useRef(new Animated.Value(0)).current;
    const popValue3 = useRef(new Animated.Value(0)).current;
    const popValue4 = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        Animated.timing(popValue1, {
            toValue: 3,
            duration: 3000,
            useNativeDriver: true,
        }).start();
        Animated.timing(popValue2, {
            toValue: 3,
            duration: 3000,
            delay: 1000,
            useNativeDriver: true,
        }).start();
        Animated.timing(popValue3, {
            toValue: 3,
            duration: 3000,
            delay: 2000,
            useNativeDriver: true,
        }).start();
        Animated.timing(popValue4, {
            toValue: 3,
            duration: 3000,
            delay: 2000,
            useNativeDriver: true,
        }).start();
    }, []);

    return (
        <Animated.View
            style={[
                styles.component,
                {
                    opacity: popValue1.interpolate({
                        inputRange: [0, 1, 2, 3],
                        outputRange: [0.2, 0.4, 0.6, 0.8],
                    }),
                },
            ]}
        >
            <Animated.View
                style={{
                    width: 40,
                    height: 40,
                    borderRadius: 20,
                    borderWidth: 5,
                    position: "absolute",
                    borderColor: config.colors.tertiary,
                    borderTopColor: config.colors.danger,
                    transform: [
                        {
                            rotate: popValue1.interpolate({
                                inputRange: [0, 1, 2, 3],
                                outputRange: [
                                    Math.floor(Math.random() * 360) + "deg",
                                    Math.floor(Math.random() * 360) + "deg",
                                    Math.floor(Math.random() * 360) + "deg",
                                    "0deg",
                                ],
                            }),
                        },
                        {
                            perspective: 1000,
                        },
                    ],
                    opacity: popValue1.interpolate({
                        inputRange: [0, 1, 2, 3],
                        outputRange: [0.4, 0.6, 0.8, 1],
                    }),
                }}
            />
            <Animated.View
                style={{
                    width: 60,
                    height: 60,
                    borderRadius: 30,
                    borderWidth: 5,
                    position: "absolute",
                    borderColor: config.colors.tertiary,
                    borderTopColor: config.colors.danger,
                    transform: [
                        {
                            rotate: popValue2.interpolate({
                                inputRange: [0, 1, 2, 3],
                                outputRange: [
                                    Math.floor(Math.random() * 360) + "deg",
                                    Math.floor(Math.random() * 360) + "deg",
                                    Math.floor(Math.random() * 360) + "deg",
                                    "0deg",
                                ],
                            }),
                        },
                        {
                            perspective: 1000,
                        },
                    ],
                    opacity: popValue2.interpolate({
                        inputRange: [0, 1, 2, 3],
                        outputRange: [0.4, 0.6, 0.8, 1],
                    }),
                }}
            />
            <Animated.View
                style={{
                    width: 80,
                    height: 80,
                    borderRadius: 40,
                    borderWidth: 5,
                    position: "absolute",
                    borderColor: config.colors.tertiary,
                    borderTopColor: config.colors.danger,
                    transform: [
                        {
                            rotate: popValue3.interpolate({
                                inputRange: [0, 1, 2, 3],
                                outputRange: [
                                    Math.floor(Math.random() * 360) + "deg",
                                    Math.floor(Math.random() * 360) + "deg",
                                    Math.floor(Math.random() * 360) + "deg",
                                    "0deg",
                                ],
                            }),
                        },
                        {
                            perspective: 1000,
                        },
                    ],
                    opacity: popValue3.interpolate({
                        inputRange: [0, 1, 2, 3],
                        outputRange: [0.4, 0.6, 0.8, 1],
                    }),
                }}
            />
            <Animated.View
                style={{
                    width: 100,
                    height: 100,
                    borderRadius: 50,
                    borderWidth: 5,
                    position: "absolute",
                    borderColor: config.colors.tertiary,
                    borderTopColor: config.colors.danger,
                    transform: [
                        {
                            rotate: popValue4.interpolate({
                                inputRange: [0, 1, 2, 3],
                                outputRange: [
                                    Math.floor(Math.random() * 360) + "deg",
                                    Math.floor(Math.random() * 360) + "deg",
                                    Math.floor(Math.random() * 360) + "deg",
                                    "0deg",
                                ],
                            }),
                        },
                        {
                            perspective: 1000,
                        },
                    ],
                    opacity: popValue4.interpolate({
                        inputRange: [0, 1, 2, 3],
                        outputRange: [0.4, 0.6, 0.8, 1],
                    }),
                }}
            />
        </Animated.View>
    );
}

const styles = StyleSheet.create({
    component: {
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
        position: "absolute",
        backgroundColor: "white",
        height: "100%",
        width: "100%",
    },
});

export default Loader;
